import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useClientStore } from '@/client/stores/client';
import { withErrorHandling } from '@/client/utils/errors';
import { BudgetUpsertPayload, BudgetUpsertResult } from '@/client/types/ai-management';
import { aiKeys, unwrapEnvelope } from './overview.query';
import { BUDGETS } from './budgets.query';

// Create when no `budget_id`, update when present — same POST endpoint.
const useUpsertBudgetFn = () => {
  const request = useClientStore((s) => s.request);
  return withErrorHandling(async (payload: BudgetUpsertPayload): Promise<BudgetUpsertResult> => {
    const raw = await request<any>(BUDGETS, 'POST', payload);
    return unwrapEnvelope<BudgetUpsertResult>(raw);
  }, 'Failed to save budget');
};

export const useUpsertBudgetMutation = () => {
  const queryClient = useQueryClient();
  const upsertFn = useUpsertBudgetFn();
  return useMutation({
    mutationFn: (payload: BudgetUpsertPayload) => upsertFn(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: aiKeys.budgets() });
    },
  });
};
